<template>
  <portal :to="globalTarget">
    <v-inlinealerts v-bind="$attrs" v-on="$listeners" :global="true" @controls="setControls" @interaction="onInteraction">
      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope"/></template>
    </v-inlinealerts>
  </portal>
</template>
<script>
let timer;

export default {
  inheritAttrs: false,
  data() {
    return {
      navigate: () => {}
    };
  },
  methods: {
    setControls($event) {
      this.navigate = $event.navigate;
      this.cycleAlert();
    },
    onInteraction() {
      clearTimeout(timer);
    },
    cycleAlert() {
      clearTimeout(timer);

      let delay = this.interval * 1000;

      timer = setTimeout(() => {
        this.navigate();
        this.$nextTick(this.cycleAlert);
      }, delay);
    }
  },
  props: {
    globalTarget: {
      type: String,
      default: "alerts"
    },
    interval: {
      type: Number,
      default: 6
    }
  }
};
</script>
